export default __webpack_public_path__ + "static/media/dole-juice-wood-bg@3x.7ac457a9.png";